import React, { useState } from "react";
import { sendOTP, sendWelcomeEmail, verifyOTP } from "../../services/apis/user";
import CustomAlert from "../../components/alert/CustomAlert"; // Import CustomAlert
import { useNavigate } from "react-router-dom";

const ResendAndVerifyOtp = () => {
    const navigate = useNavigate();
    const [otp, setOtp] = useState("");
    const [alert, setAlert] = useState(null); // State for CustomAlert

    const handleOtpChange = (e) => {
        setOtp(e.target.value);
    };

    const handleVerifyOtp = async () => {
        try {
            const userId = localStorage.getItem("userId");
            const otpResponse = await verifyOTP(userId, otp);
            if (otpResponse.success) {
                setAlert({
                    message: "OTP Verification successful!",
                    type: "success",
                });
                await sendWelcomeEmail(userId);
                navigate("/login");
            } else {
                setAlert({
                    message: "OTP Not Valid!",
                    type: "error",
                });
                console.error("Error verifying OTP:", otpResponse.error);
            }
        } catch (error) {
            console.error("Error verifying OTP:", error);
            setAlert({
                message: "Error verifying OTP. Please try again later.",
                type: "error",
            });
        }
    };

    const handleResendOtp = async () => {
        try {
            const userId = localStorage.getItem("userId");
            const otpResponse = await sendOTP(userId);
            if (otpResponse.success) {
                setAlert({
                    message: "OTP Sent.",
                    type: "success",
                });
            } else {
                console.error("Error sending OTP:", otpResponse.error);
                setAlert({
                    message: "Error sending OTP.",
                    type: "error",
                });
            }
        } catch (error) {
            console.error("Error:", error);
            setAlert({
                message: "Failed to resend OTP. Please try again later.",
                type: "error",
            });
        }
    };

    return (
        <div className="flex justify-center items-center h-screen bg-[#E2F5EC]">
            <div className="w-full max-w-md bg-white rounded-[20px] shadow-md p-6">
                <h1 className="text-[#067C4E] text-[24px] font-medium leading-[36px] text-center">
                    Verify OTP
                </h1>
                <p className="text-[14px] font-normal leading-snug text-center text-black mt-2">
                    Enter the OTP sent to your registered mobile number.
                </p>

                <div className="mt-6">
                    <label
                        htmlFor="otp"
                        className="text-black text-[14px] leading-[21px] font-normal ml-2"
                    >
                        OTP<span className="text-red-600"> *</span>
                    </label>
                    <input
                        id="otp"
                        name="otp"
                        value={otp}
                        onChange={handleOtpChange}
                        placeholder="Enter OTP"
                        className="w-full border pl-4 rounded-[10px] h-[50px] border-[#B9B9B9] mt-2"
                        type="text"
                    />
                </div>

                <div className="mt-6 flex justify-center gap-4">
                    <button
                        onClick={handleVerifyOtp}
                        className="h-[44px] rounded-[100px] py-[10px] px-[25px] text-white text-[16px] leading-[24px] bg-[#067C4E] hover:bg-[#055C3A]"
                    >
                        Verify OTP
                    </button>
                    <button
                        onClick={handleResendOtp}
                        className="h-[44px] rounded-[100px] py-[10px] px-[25px] text-[#067C4E] text-[16px] leading-[24px] border border-[#067C4E] hover:bg-[#E2F5EC]"
                    >
                        Resend OTP
                    </button>
                </div>
            </div>
            {alert && (
                <CustomAlert
                    message={alert.message}
                    type={alert.type}
                    onClose={() => setAlert(null)}
                />
            )}
        </div>
    );
};

export default ResendAndVerifyOtp;
